module.exports = __webpack_public_path__ + "img/bgPurpleYellow.aa8f8a0e.png";